import Clarity from '@microsoft/clarity';
import { RootState } from '@redux/store';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const isClarityEnabled = import.meta.env.VITE_CLARITY_ENABLED === 'true';
const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

// Module-scoped so it survives component remounts (strict mode, HMR, etc.)
let lastIdentifiedUserId: string | null = null;

export const initClarity = () => {
  if (!isClarityEnabled || !clarityProjectId) return;
  try {
    Clarity.init(clarityProjectId);
  } catch (e) {
    console.error('Failed to initialize Clarity', e);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyRecord = { [key: string]: any };

const ClarityComponent = () => {
  const auth = useSelector((s: RootState) => s.auth) as AnyRecord;
  const profile = useSelector((s: RootState) => s.profile) as AnyRecord;

  useEffect(() => {
    if (!isClarityEnabled || !auth?.accessToken || !profile?.mobile) return;

    const userId = String(profile.mobile);
    if (lastIdentifiedUserId === userId) return;

    const name: string | undefined = profile.profileDetails?.name;

    try {
      Clarity.identify(userId, undefined, undefined, name ?? userId);
      Clarity.setTag('mobile', userId);
      if (name) Clarity.setTag('name', name);
      lastIdentifiedUserId = userId;
    } catch (e) {
      console.error('Failed to set Clarity user context', e);
    }
  }, [auth?.accessToken, profile?.mobile, profile?.profileDetails?.name]);

  return null;
};

export default ClarityComponent;
